import {NgModule} from '@angular/core';
import {ConfigServices} from './services/config.services';
import {UsuarioServices} from './services/usuario.services';
import {LoginComponent} from './components/login.component';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DashboardComponent} from './components/dashboard.component';
import {CoreRoutingModule} from './core.routing.module';
import {CoreSecurityServices} from './services/core.security.services';
import {RolServices} from './services/rol.services';
import {MenuComponent} from './components/menu.component';
import {CollapseModule} from 'ngx-bootstrap';
import {CargoServices} from './services/cargo.services';
import {ExcelServices} from './services/excel.services';
import {ComboChartComponent} from './Misc/components/combo-chart.component';
import {ComboSeriesVerticalComponent} from './Misc/components/combo-series-vertical.component';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {RegionalServices} from './services/regional.services';
import {SocketServices} from './services/socket.services';
import {LogServices} from './services/log.services';
import {PdfServices} from './services/pdf.services';

@NgModule({
  declarations: [LoginComponent, DashboardComponent, MenuComponent, ComboChartComponent,
    ComboSeriesVerticalComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    CoreRoutingModule,
    CollapseModule,
    NgxChartsModule

  ],
  providers: [ConfigServices, UsuarioServices, CoreSecurityServices, RolServices, CargoServices, ExcelServices,
    RegionalServices, SocketServices, LogServices, PdfServices],
  exports: [MenuComponent, ComboChartComponent, ComboSeriesVerticalComponent]
})
export class CoreModule {

}



